export default {
	data() {
		return {
			dialogConfig: {},
			showDialog: false
		}
	},
	methods: {
		openErrDialog(icon, title, successBackName, successBackParams, warningInfo, confirmBtnName, cancelBtnName, cancelBackName, cancelBackParams) {
			this.showDialog = true
			this.dialogConfig = {
				icon,
				title,
				successBackName,
				successBackParams,
				warningInfo,
				confirmBtnName,
				cancelBtnName,
				cancelBackName,
				cancelBackParams
			}
		},
		definedBack(val, params) {
			this[val](params)
		}
	}
}
